import { addRest, getValue } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function timeIntervals2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        obj.sm + obj.sh * (1 << 8) + obj.em * (1 << 16) + obj.eh * (1 << 24),
        obj.temperature || 2730,
        obj.action_register,
        ...(obj.rest || []),
    ]);
}
function timeIntervalsFromStr(id, params) {
    const byte_field = getValue(params, 0, 0);
    return {
        id: id,
        sm: byte_field & 255,
        sh: (byte_field & (255 << 8)) >> 8,
        em: (byte_field & (255 << 16)) >> 16,
        eh: (byte_field & (255 << 24)) >> 24,
        temperature: getValue(params, 1, 0),
        action_register: getValue(params, 2, 0),
        ...addRest(params, 3),
    };
}
export const time_interval_parser = {
    toStr: timeIntervals2Str,
    fromStr: timeIntervalsFromStr,
};
